import SignupButtonDefaultProps from "segments/desktop/core-components/button/signup-button/default-props";
import ContactSalesButtonDefaultProps from "segments/desktop/core-components/contact-sales-button/default-props";
export default {
    signupButtonConfig: SignupButtonDefaultProps,
    contactSalesButtonConfig: ContactSalesButtonDefaultProps,
    swapButtonsOrder: false
};
